export default "__VITE_ASSET__Dl40xOAl__"